import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManagePlan() {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function addPlan(data) {
    return privateFetch.post(`/v1/admin/plan`, data);
  }

  function updatePlan({ id: planID, ...rest } = {}) {
    return privateFetch.put(`/v1/admin/plan/${planID}`, rest);
  }

  function managePlan(data) {
    if (data.id) return updatePlan(data);

    return addPlan(data);
  }

  return useMutation(managePlan, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('plan');
    },
  });
}

export default useManagePlan;
